module.exports = __webpack_public_path__ + "media/images/static/top/urban/left_photo_mobile-5aa61058b8d617517ce328b369739288.png";